import styles from './SearchBar.module.css';

interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  fullWidth?: boolean;
}

export default function SearchBar({ placeholder, value, onChange, fullWidth }: SearchBarProps) {
  return (
    <div className={`${styles.wrap} ${fullWidth ? styles.wrapFull : ''}`}>
      <svg
        className={styles.icon}
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <input
        className={`${styles.input} ${fullWidth ? styles.inputFull : ''}`}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        aria-label={placeholder ?? 'Search'}
      />
    </div>
  );
}
